import { Persona } from "./persona.model";
import ITrabajador from "./trabajador.interface";

export class Trabajador extends Persona implements ITrabajador {
}